import CustomerPaymentMethodAdmin from 'src/adminPanel/entities/office/paymentMethod/CustomerPaymentMethod';
import { action } from 'src/store/actions';

/* Customer Payment Methods */
export const FETCH_CUSTOMER_PAYMENT_METHODS = 'FETCH_CUSTOMER_PAYMENT_METHODS';
export const REQUEST_CUSTOMER_PAYMENT_METHODS = 'REQUEST_CUSTOMER_PAYMENT_METHODS';
export const SUCCESS_CUSTOMER_PAYMENT_METHODS = 'SUCCESS_CUSTOMER_PAYMENT_METHODS';
export const FAILURE_CUSTOMER_PAYMENT_METHODS = 'FAILURE_CUSTOMER_PAYMENT_METHODS';

export const fetchCustomerPaymentMethods = () => action(FETCH_CUSTOMER_PAYMENT_METHODS);
export const requestCustomerPaymentMethods = () => action(REQUEST_CUSTOMER_PAYMENT_METHODS);
export const requestCustomerPaymentMethodsSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_PAYMENT_METHODS, { response });
export const requestCustomerPaymentMethodsFailure = (error: any) => action(FAILURE_CUSTOMER_PAYMENT_METHODS, { error });

export const ADD_CUSTOMER_PAYMENT_METHOD = 'ADD_CUSTOMER_PAYMENT_METHOD';
export const REQUEST_ADD_CUSTOMER_PAYMENT_METHOD = 'REQUEST_ADD_CUSTOMER_PAYMENT_METHOD';
export const SUCCESS_ADD_CUSTOMER_PAYMENT_METHOD = 'SUCCESS_ADD_CUSTOMER_PAYMENT_METHOD';
export const FAILURE_ADD_CUSTOMER_PAYMENT_METHOD = 'FAILURE_ADD_CUSTOMER_PAYMENT_METHOD';

export const addCustomerPaymentMethod = (customerPaymentMethod: CustomerPaymentMethodAdmin) =>
    action(ADD_CUSTOMER_PAYMENT_METHOD, { customerPaymentMethod });
export const requestAddCustomerPaymentMethod = () => action(REQUEST_ADD_CUSTOMER_PAYMENT_METHOD);
export const requestAddCustomerPaymentMethodSuccess = (response: any) =>
    action(SUCCESS_ADD_CUSTOMER_PAYMENT_METHOD, { response });
export const requestAddCustomerPaymentMethodFailure = (error: any) =>
    action(FAILURE_ADD_CUSTOMER_PAYMENT_METHOD, { error });

export const DEACTIVATE_CUSTOMER_PAYMENT_METHOD = 'DEACTIVATE_CUSTOMER_PAYMENT_METHOD';
export const REQUEST_DEACTIVATE_CUSTOMER_PAYMENT_METHOD = 'REQUEST_DEACTIVATE_CUSTOMER_PAYMENT_METHOD';
export const SUCCESS_DEACTIVATE_CUSTOMER_PAYMENT_METHOD = 'SUCCESS_DEACTIVATE_CUSTOMER_PAYMENT_METHOD';
export const FAILURE_DEACTIVATE_CUSTOMER_PAYMENT_METHOD = 'FAILURE_DEACTIVATE_CUSTOMER_PAYMENT_METHOD';

export const deactivateCustomerPaymentMethod = (customerPaymentMethodId: number) =>
    action(DEACTIVATE_CUSTOMER_PAYMENT_METHOD, { customerPaymentMethodId });
export const requestDeactivateCustomerPaymentMethod = () => action(REQUEST_DEACTIVATE_CUSTOMER_PAYMENT_METHOD);
export const requestDeactivateCustomerPaymentMethodSuccess = (response: any) =>
    action(SUCCESS_DEACTIVATE_CUSTOMER_PAYMENT_METHOD, { response });
export const requestDeactivateCustomerPaymentMethodFailure = (error: any) =>
    action(FAILURE_DEACTIVATE_CUSTOMER_PAYMENT_METHOD, { error });

/* Admin Customer Paymnent Methods */
export const FETCH_CUSTOMER_PAYMENT_METHODS_ADMIN = 'FETCH_CUSTOMER_PAYMENT_METHODS_ADMIN';
export const REQUEST_CUSTOMER_PAYMENT_METHODS_ADMIN = 'REQUEST_CUSTOMER_PAYMENT_METHODS_ADMIN';
export const SUCCESS_CUSTOMER_PAYMENT_METHODS_ADMIN = 'SUCCESS_CUSTOMER_PAYMENT_METHODS_ADMIN';
export const FAILURE_CUSTOMER_PAYMENT_METHODS_ADMIN =
    'FAILFAILURE_CUSTOMER_PAYMENT_METHODS_ADMINURE_CUSTOMER_PAYMENT_METHODS';

export const fetchCustomerPaymentMethodsAdmin = () => action(FETCH_CUSTOMER_PAYMENT_METHODS_ADMIN);
export const requestCustomerPaymentMethodsAdmin = () => action(REQUEST_CUSTOMER_PAYMENT_METHODS_ADMIN);
export const requestCustomerPaymentMethodsAdminSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_PAYMENT_METHODS_ADMIN, { response });
export const requestCustomerPaymentMethodsAdminFailure = (error: any) =>
    action(FAILURE_CUSTOMER_PAYMENT_METHODS_ADMIN, { error });
